import { finalize, map, shareReplay } from 'rxjs/operators';
import {
    FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE,
    IFirmsAndInstrumentsAdapterService,
} from '../message-adapters/firms-and-instruments-adapter';
import { flattenInstruments } from './all-available-instruments.utils';
import { IAllAvailableInstrumentsService } from './all-available-instruments.interface';
import { IInstrument } from '../../interfaces';
import { inject, injectable } from 'inversify';
import { Observable } from 'rxjs';

@injectable()
export class AllAvailableInstrumentsService implements IAllAvailableInstrumentsService {

    private instruments$: Observable<Array<IInstrument>>;

    @inject(FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE) private readonly firmsInstrumentsAdapter: IFirmsAndInstrumentsAdapterService;

    asObservable(): Observable<Array<IInstrument>> {
        if (!Boolean(this.instruments$)) {
            this.instruments$ = this.firmsInstrumentsAdapter.asObservable()
                .pipe(
                    finalize(() => delete this.instruments$),
                    map(flattenInstruments),
                    shareReplay(1),
                );
        }

        return this.instruments$;
    }
}
